import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import defineDeviceState from "@src/composables/defineDeviceState";
import { ref, watch } from "vue";
import BmbDevice from "@src/components/prototype/BmbDevice.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Device',
  setup(__props) {

const deviceState = defineDeviceState();

const id = ref(0);
watch(
  () => deviceState.modules.value,
  () => {
    id.value++;
  },
);

function getModuleKey(index: number): number {
  return index + id.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("  <BmbDevice />"),
    _createElementVNode("div", {
      class: _normalizeClass(["device", ['device-width-' + _unref(deviceState).modulesWidth.value]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceState).modules.value, (module, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(module.component), {
          key: getModuleKey(index),
          index: index,
          status: module.state,
          difficulty: _unref(deviceState).difficultyLevel.value,
          "serial-number": _unref(deviceState).serialNumber.value,
          onDisarm: () => _unref(deviceState).disarmModule(index),
          onFail: () => _unref(deviceState).failModule(index)
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["index", "status", "difficulty", "serial-number", "onDisarm", "onFail"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})